import { Translation, Translator } from '@morningtrain/react-translations'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'
import { EditAmoMemberSmartview } from 'widgets/smartviews/amo/EditAmoMemberSmartview'
import { Collection, ForEachModel } from '@morningtrain/react-resources'
import React from 'react'
import * as Displays from '@morningtrain/react-displays'
import TruncatedList from 'support/displays/TruncatedList'
import * as UI from 'ui'
import { Can } from '@morningtrain/react-auth'
import Permissions from 'services/Permissions'

export function AmoMembers () {
  return (
    <Translator namespace='hr.amo.members'>
      <div>
        <UI.Card tight>
          <UI.CardHeader withMargin={false} withPadding={false} className='my-4  mx-8'>
            <UI.SecondaryHeading>
              <Translation name='header' />
            </UI.SecondaryHeading>
            <Can permission={Permissions.HR_MANAGE_AMO}>
              <MountSmartviewWithModelOnClick smartview={<EditAmoMemberSmartview create />} replace={false}>
                <UI.Button>
                  <Translation name='actions.create' />
                </UI.Button>
              </MountSmartviewWithModelOnClick>
            </Can>
          </UI.CardHeader>
        </UI.Card>

        <Collection resourceName='amo.amo_member'>
          <UI.FlexGrid className='mt-4 mb-12' cols={1} responsive={{ xl: 4, lg: 3 }}>
            <ForEachModel>
              <Can permission={Permissions.HR_MANAGE_AMO}>
                <MountSmartviewWithModelOnClick smartview={<EditAmoMemberSmartview />} replace={false}>
                  <UI.SmallCardWithImage
                    title={<Displays.Text name='user.name' />}
                    subtitle={<Displays.Enum name='type' enum='amo_member_type' />}
                    image={<Displays.Image name='user.avatar_url' />}
                    text={<TruncatedList name='departments' max={2} keyName='name' />}
                  />
                </MountSmartviewWithModelOnClick>
              </Can>
              <Can permission={Permissions.HR_MANAGE_AMO} negate>
                <UI.SmallCardWithImage
                  title={<Displays.Text name='user.name' />}
                  subtitle={<Displays.Enum name='type' enum='amo_member_type' />}
                  image={<Displays.Image name='user.avatar_url' />}
                  text={<TruncatedList name='departments' max={2} keyName='name' />}
                />
              </Can>
            </ForEachModel>
          </UI.FlexGrid>
        </Collection>
      </div>
    </Translator>
  )
}
